<mat-chip-grid #chipList [disabled]="disabled">
  @for (v of value; track v) {
    <mat-chip-option [removable]="!disabled" (removed)="onRemove(v)" [disabled]="disabled">
      {{ v | lcsChipDisplay : getDisplayText }}
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip-option>
  }
  <input [matChipInputFor]="chipList" disabled />
</mat-chip-grid>
